import { render, staticRenderFns } from "./OptionSales.vue?vue&type=template&id=6b51748c&scoped=true"
import script from "./OptionSales.vue?vue&type=script&lang=js"
export * from "./OptionSales.vue?vue&type=script&lang=js"
import style0 from "./OptionSales.vue?vue&type=style&index=0&id=6b51748c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b51748c",
  null
  
)

export default component.exports